import React from "react";
import {
  Flex,
  Modal,
  Button,
} from "antd";
import PartyIcon from "./PartyIcon";

const selectedTabStyle = { backgroundColor: "#fa5705", color: "white" };

const PartyDetailsModal = ({
  guestModalVisible,
  setGuestModalVisible,
  guests,
  isShared,
}) => {
  return (
    <Modal
      title="Guests"
      open={guestModalVisible}
      onCancel={() => setGuestModalVisible(false)}
      onOk={() => setGuestModalVisible(false)}
      okButtonProps={{ style: { backgroundColor: "green" } }}
    >
      <Flex justify="center" vertical>
        {["adults", "children", "elderly"].map((type) => (
          <Flex
            justify="space-between"
            key={type}
            style={{
              marginBottom: 10,
            }}
          >
            <span>{type.charAt(0).toUpperCase() + type.slice(1)}</span>
            <div>
             
              <span style={{ margin: "0 10px" }}>{guests[type]}</span>
             
            </div>
          </Flex>
        ))}
        <Button.Group>
          <Button
            type={ "primary"}
            size="large"
            style={{ ...( selectedTabStyle), width: "100%" }}
            icon={<PartyIcon partyType={"private"} />}
            disabled={true}
          >
            {isShared ? "Shared" : "Private"}
          </Button>
        </Button.Group>
      </Flex>
    </Modal>
  );
};

export default PartyDetailsModal;
